import React from 'react'
import EasingMotion from './easing-motion'
import { spring } from 'react-motion'
import colors from '../colors'
import I18n from 'lib/components/i18n'
import { FONT_LARGE, FONT_FAMILY, SPRING } from '../constants'
import { guardProps } from './validate'

class EasingTick extends React.PureComponent {
  static defaultProps = {
    align: 'middle',
    baseline: 'mathematical',
    className: '',
    x: 0,
    y: 0,
    height: 0,
    width: 0,
    fontSize: FONT_LARGE,
    fontFamily: FONT_FAMILY,
    fill: colors.label
  }

  renderTick({ x, y }) {
    return (
      <I18n tag="text" className="axis__tick" x={x} y={y}>
        {this.props.label}
      </I18n>
    )
  }

  render() {
    const {
      align,
      baseline,
      className,
      fill,
      fontSize,
      fontFamily,
      height,
      width,
      x,
      y
    } = this.props

    if (guardProps(this, 'x', 'y')) {
      return null
    }

    const params = {
      x: x + width * 0.5,
      y: y + height * 0.5
    }

    const style = {
      x: spring(params.x, SPRING),
      y: spring(params.y, SPRING)
    }

    return (
      <g
        className={className}
        fontSize={fontSize}
        fontFamily={fontFamily}
        textAnchor={align}
        dominantBaseline={baseline}
        fill={fill}
      >
        <EasingMotion style={style} static={params}>
          {style => this.renderTick(style)}
        </EasingMotion>
      </g>
    )
  }
}

export default EasingTick



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/shapes/easing-tick.js